// Formats a whole-kroner amount as a localized DKK currency string (no decimals).
export function formatDkk(amount: number, language: string): string {
  return new Intl.NumberFormat(language, {
    style: 'currency',
    currency: 'DKK',
    maximumFractionDigits: 0
  }).format(amount);
}

// The bare DKK unit label for the active language ("kr." in Danish, "DKK" in English), for inputs
// that render the editable number themselves and only need the unit beside it.
export function getDkkSymbol(language: string): string {
  const parts = new Intl.NumberFormat(language, {
    style: 'currency',
    currency: 'DKK'
  }).formatToParts(0);
  return parts.find((part) => part.type === 'currency')?.value ?? 'DKK';
}
